import React, {memo, useEffect, useRef, useState} from 'react';
import Header from './header';
import NotificationCenter from '../informers';
import ToastList from '../toasts';
import {checkingPages, isDesktop, isDesktopLarge, isGuest, mobileAndTabletCheck} from 'app/utils';
import {showBetForm} from '../table';
import {TapBar} from './tap_bar';
import $ from 'jquery';
import {tableStore, configStore} from 'app/store/global';
import SmartStoriesMobile from 'app/components/pages/home_page/SmartStories/SmartStoriesMobile';
import {isBetPage} from 'app/utils/IsBetPage';
import {isMainPage} from 'app/utils/isMainPage';
import BetSlipContainer from 'app/components/bet_slip/BetSlip.container';
import Footer from 'site_version/common/Footer';
import BarLoginMobile from 'app/components/auth/BarLoginMobile';
import {useOutlet} from 'react-router';
import {useLocation} from 'react-router-dom';
import {isSportPage} from 'app/utils/isSportPage';
import Aside from 'site_version/com/Aside';
import AsideLeft from 'site_version/com/AsideLeft';
import {DESKTOP_MIN_WIDTH} from 'app/utils/windowFunctions';
import PageErrorBoundary from 'app/components/routes/PageErrorBoundary';

const NOT_FOUND_INDEX = -1;

const isHomePage = () => {
    const {pathname} = location;

    return pathname === '/' || configStore.LOCALES.indexOf(pathname.replace(/\//gu, '')) !== NOT_FOUND_INDEX;
};

const homeOrDesktop = () => isHomePage() || isDesktop();

const isChatMobile = () => {
    const {pathname} = location;
    return pathname.search('chat/mobile') !== NOT_FOUND_INDEX;
};

// eslint-disable-next-line max-statements, complexity
const AppPageWrapper = memo(() => {
    const outlet = useOutlet();
    const location = useLocation();

    const [state, setState] = useState({
        height: '500px',
        heightContent: '0px',
        key: '',
        marginBottom: '0px',
        marginTop: '70px',
        pathname: null
    });

    const contentRef = useRef(null);
    const wrapRef = useRef(null);

    const reactContentRef = useRef(null);
    let resizeObserver = null;

    useEffect(() => {
        setViewport();
    }, []);

    const setViewport = () => {
        if (!mobileAndTabletCheck() && screen.width < DESKTOP_MIN_WIDTH) {
            const viewport = `width=${DESKTOP_MIN_WIDTH}, maximum-scale=4.0`;
            $('meta[name=viewport]').attr('content', viewport);
        }
    };

    const updateHeight = (height?: string | number) => {
        const marginTop = height ? height : $('.header').outerHeight();
        const marginBottom = isDesktop() ? 0 : $('.tap_bar').outerHeight();

        setState(prevState => ({
            ...prevState,
            marginBottom: `${marginBottom}px`,
            marginTop: `${marginTop}px`
        }));
    };

    const updateContentPosition = () => {
        const heightContentAdaptive = $('#react-content').outerHeight() - $(window).height();

        setState(prevState => ({
            ...prevState,
            heightContent: `-${heightContentAdaptive}px`
        }));
    };

    useEffect(() => {
        tableStore.startUpdateLines();

        const betId = location.hash.substr(1);

        if ((checkingPages.isPlayPage() || isMainPage()) && betId && betId.length > 0 && !betId.includes('auth')) {
            showBetForm({id: betId});
        }

        updateHeight();

        const handleResize = () => updateHeight();
        window.addEventListener('resize', handleResize, false);

        if (isDesktop()) {
            resizeObserver = new ResizeObserver(updateContentPosition);
            resizeObserver.observe(reactContentRef.current, {childList: true, subtree: true});
        }

        return () => {
            window.removeEventListener('resize', handleResize, false);
            resizeObserver?.disconnect();
        };
    }, []);

    const isHomePageClassName = () => isHomePage() ? ' home-page' : '';

    const topStyleContent = isDesktop() ? {top: state.heightContent} : {};

    return <div className="app__inner">
        <Header updateHeight={updateHeight}/>
        <div className="notification">
            <NotificationCenter />
        </div>
        <div className="notification">
            <ToastList />
        </div>

        <div
            className={`main-block${isHomePageClassName()}`}
            style={{
                marginBottom: state.marginBottom,
                marginTop: state.marginTop
            }}>
            <div ref={wrapRef} className="wrap wrap--content wrap--new-asides">
                {isDesktopLarge() && !isChatMobile() && <AsideLeft/>}
                <div
                    ref={reactContentRef}
                    id="react-content"
                    className="content"
                    style={topStyleContent}
                >
                    <div ref={contentRef} className="content__inner ">
                        {!isDesktop() && isBetPage(true) && <SmartStoriesMobile/>}

                        <PageErrorBoundary path={location.pathname}>
                            {outlet}
                        </PageErrorBoundary>

                        {isHomePage() && !isDesktop() && isGuest() && <BarLoginMobile/>}

                        {isDesktop() && <Footer/>}
                    </div>
                </div>
                {homeOrDesktop() && !isChatMobile() && !isSportPage() && <Aside
                    hideChat={isHomePage() && !isDesktop()}
                />}
                {!isDesktop() && isHomePage() && <Footer/>}
            </div>
        </div>
        <BetSlipContainer/>

        {!isDesktop() && <TapBar/>}
    </div>;
});

export default AppPageWrapper;
